import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MarkdownElement from '@material-ui/docs/MarkdownElement';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
/* eslint import/no-webpack-loader-syntax: off */
import releases from '!raw-loader!./releases.md';
import vdeDatasetViewerReleases from '!raw-loader!../vde-dataset-viewer/releases/vdeDatasetViewerReleases.md';

const styles = theme => ({
    root: {
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing.unit * 3,
    },
    button: {
        margin: theme.spacing.unit,
        minWidth: '200px',
    },
});


function Releases(props) {
    const { classes } = props;
    const [selectedApp, setSelectedApp] = useState('dataset-viewer');

    return (
        <div className={classes.root}>
            <div className={classes.buttonsContainer}>
                <Button
                    variant={selectedApp === 'define-xml' ? 'contained' : 'outlined'}
                    color="primary"
                    className={classes.button}
                    onClick={() => setSelectedApp('define-xml')}
                >
                    Visual Define-XML Editor
                </Button>
                <Button
                    variant={selectedApp === 'dataset-viewer' ? 'contained' : 'outlined'}
                    color="primary"
                    className={classes.button}
                    onClick={() => setSelectedApp('dataset-viewer')}
                >
                    VDE Dataset Viewer
                </Button>
            </div>

            <MarkdownElement text={selectedApp === 'define-xml' ? releases : vdeDatasetViewerReleases} />
        </div>
    );
}

Releases.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Releases);
